export const NOTE_MAX_LENGTH = 150;

// Shared column widths so the accordion header and the attestation rows stay aligned.
export const attestationColumns = {
  discipline: { label: "Дисциплина", md: 3 },
  classType: { label: "Тип занятие", md: 2 },
  status: { label: "Статус", md: 2 },
  professor: { label: "Преподавател", md: 2.5 },
  note: { label: "Бележка", md: 2 },
  actions: { label: "", md: 0.5 },
};
